module.exports = __webpack_public_path__ + "img/logo.5719286e.svg";